import {
    Component,
    OnInit,
    Input,
    Inject,
    PLATFORM_ID,
    OnChanges,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Router } from "@angular/router";
import { EmbryoService } from "../../Services/Embryo.service";
@Component({
    selector: "app-banners",
    templateUrl: "./banners.component.html",
    styleUrls: ["./banners.component.scss"],
})
export class BannersComponent implements OnInit, OnChanges {
    @Input() banners: Array<any> = [];
    // @Input() title: string;
    lang: any;

    constructor(
        private languagesService: EmbryoService,
        private translate: TranslateService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.languagesService.emitLang.subscribe((item: string) => {
            translate.setDefaultLang(item);
            this.lang = item;
        });
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.lang = localStorage.getItem("lang");
        }
        if (this.banners && this.banners.length) {
            this.banners.forEach((element) => {
                if (element.item_data && element.item_data.name != undefined) {
                    element.nameRouter = encodeURIComponent(
                        element.item_data.name.replace(/\s/g, "-")
                    );
                }
            });
        }
    }

    ngOnChanges() {
        if (this.banners && this.banners.length) {
            this.banners.forEach((element) => {
                if (element.item_data && element.item_data.name != undefined) {
                    element.nameRouter = encodeURIComponent(
                        element.item_data.name.replace(/\s/g, "-")
                    );
                }
            });
        }
    }

    public getBanner(index: number) {
        return this.banners[index];
    }

    public getBgImage(index: number) {
        if (
            index != null &&
            this.lang == "en" &&
            this.banners[index].image_en
        ) {
            return this.banners[index].image_en;
        } else if (
            index != null &&
            this.lang == "ar" &&
            this.banners[index].image_ar
        ) {
            return this.banners[index].image_ar;
        } else {
            this.banners[index].placeholder = true;
            return "/assets/images/placeholder200.jpg";
        }
        // (index != null) ? this.banners[index].image_web : 'https://via.placeholder.com/600x400/ff0000/fff/';
    }
    slugify(slug: any) {
        return slug.replace("(", "-").replace(")", "-");
    }
    openLink(index: any, type: any) {
        switch (type) {
            case null:
                return;
            case 0:
                return;
            case 1:
                var link = this.slugify(this.getBanner(index).link);
                var slug_name = this.slugify(this.getBanner(index).name);
                this.router.navigateByUrl(
                    "/" +
                        this.lang +
                        `/products/` +
                        (link
                            ? link
                            : slug_name +
                              "/" +
                              this.getBanner(index).item_id +
                              "?variant=" +
                              this.getBanner(index).item_id)
                );
                break;
            case 2:
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: {
                        sub_category_id: this.getBanner(index).item_id,
                    },
                });
                break;
            case 3:
                this.router.navigate(["/" + this.lang + "/prescriptions"]);
                break;
            case 4:
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: { brand_id: this.getBanner(index).item_id },
                });
                break;
            case 5:
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: { list_ids: this.getBanner(index).item_id },
                });
                break;
            case 6:
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: {
                        category_id: this.getBanner(index).item_id,
                    },
                });
                break;
            case 8:
                this.router.navigate(["/" + this.lang + "/products"], {
                    queryParams: {
                        group_id: this.getBanner(index).item_id,
                    },
                });
                break;
            case 7:
                window.open(this.getBanner(index).link, "_self");
                break;
        }
    }

    // openLink(link: any) {
    //   if (link) {
    //     window.open(link, '_self');
    //   }
    // }


 getImageName(imageSrc :any) {
      if(imageSrc){
      var imageSrcParts = imageSrc?.split('/');
      var imageName = imageSrcParts[imageSrcParts?.length - 1];
      return imageName;
    }
  }


}
